import it from "./it";

const locales = {it};

export default locales;
